import React, { useState, useEffect } from 'react';
import { Auth, API } from 'aws-amplify';
import { Pie, Doughnut } from 'react-chartjs-2';
import { Chart, ArcElement } from 'chart.js';
import 'chartjs-plugin-datalabels';
import './ReconciliationMetricsDisplay.css'

Chart.register(ArcElement);



function ReconciliationMetricsDisplay({ recentResult, configData, filename1, filename2 }) {
    // State for file status
    console.log(recentResult)
    const [fileStatus, setFileStatus] = useState({
        filename1: 'Checking...',
        filename2: 'Checking...'
    });




    const { filename1: recentFilename1, filename2: recentFilename2 } = recentResult;



    // Function to fetch all files from the API
    const fetchAllFiles = async () => {
        try {
            const user = await Auth.currentAuthenticatedUser();
            const organization = user.attributes['email'].split('@')[1].split('.')[0];
            const apiName = 'FetchS3Files';
            const path = '/fetchs3files';

            const response = await API.post(apiName, path, { body: { organization } });
           
            return response.files;
        } catch (error) {
           
            throw new Error('Failed to fetch file list.');
        }
    };

    // Function to check if a specific file is present in the list
    const checkFilePresence = async (filename) => {
        try {
         
            const files = await fetchAllFiles();

            // Check if the file is in the fetched list
            const fileExists = files.some(file => file.key === filename);
      
            return fileExists;
        } catch (error) {
      
            return false;
        }
    };
    



    const getStatusCounts = () => {
        const breaks = recentResult.all_breaks.display_breaks.breaks;
        const statusCounts = {
            'Unresolved': 0,
            'In-Progress': 0,
            'Resolved': 0
        };

        breaks.forEach(breakItem => {
            if (statusCounts[breakItem.status] !== undefined) {
                statusCounts[breakItem.status]++;
            }
        });

        return statusCounts;
    };

    const statusCounts = getStatusCounts();

    useEffect(() => {
      
        if (filename1 && filename2) {
            (async () => {
                const file1Exists = await checkFilePresence(filename1);
                const file2Exists = await checkFilePresence(filename2);
    
                setFileStatus({
                    filename1: file1Exists ? 'Present' : 'Missing',
                    filename2: file2Exists ? 'Present' : 'Missing'
                });
            })();
        }
    }, [filename1, filename2]);

    const formatValue = (columnName, value) => {
        const isDecimal = value % 1 !== 0;
        let formattedValue = isDecimal ? value.toFixed(2) : value.toString();
    
        if (columnName.toLowerCase().includes("price") || columnName.toLowerCase().includes("amount")) {
            formattedValue = `$${formattedValue}`;
        }
        return formattedValue;
    };
    
    

    const metrics = JSON.parse(recentResult.metrics);
    const breakCounts = JSON.parse(recentResult.break_counts);
    
    // Extract values for matched breaks and mismatched breaks
    const matchedAmountSet1 = parseFloat(metrics.find(m => m.Metric === 'Matched Amount')['Set 1:']);
    const matchedBreaksSet1 = parseFloat(metrics.find(m => m.Metric === 'Matched Breaks')['Set 1:']);
    const matchedBreaksSet2 = parseFloat(metrics.find(m => m.Metric === 'Matched Breaks')['Set 2:']);
    const mismatchedBreaksSet1 = parseFloat(metrics.find(m => m.Metric === 'Mismatched Breaks')['Set 1:']);
    const mismatchedBreaksSet2 = parseFloat(metrics.find(m => m.Metric === 'Mismatched Breaks')['Set 2:']);
    const resolvedMismatchedBreaksSet1 = parseFloat(metrics.find(m => m.Metric === 'Resolved Mismatched Breaks')['Set 1:']);
    const resolvedMismatchedBreaksSet2 = parseFloat(metrics.find(m => m.Metric === 'Resolved Mismatched Breaks')['Set 2:']);
    const resolvedMatchedBreaksSet1 = parseFloat(metrics.find(m => m.Metric === 'Resolved Matched Breaks')['Set 1:']);
    const resolvedMatchedBreaksSet2 = parseFloat(metrics.find(m => m.Metric === 'Resolved Matched Breaks')['Set 2:']);
    const InProgressMismatchedBreaksSet1 = parseFloat(metrics.find(m => m.Metric === 'In-Progress Mismatched Breaks')['Set 1:']);
    const InProgressMismatchedBreaksSet2 = parseFloat(metrics.find(m => m.Metric === 'In-Progress Mismatched Breaks')['Set 2:']);
    const InProgressMatchedBreaksSet1 = parseFloat(metrics.find(m => m.Metric === 'In-Progress Matched Breaks')['Set 1:']);
    const InProgressMatchedBreaksSet2 = parseFloat(metrics.find(m => m.Metric === 'In-Progress Matched Breaks')['Set 2:']);

    
    // Calculate Unmatched Amount
    const unmatchedAmountSet = matchedBreaksSet1 + mismatchedBreaksSet1 + mismatchedBreaksSet2 + InProgressMatchedBreaksSet1 + InProgressMismatchedBreaksSet1 + InProgressMismatchedBreaksSet2

    const matchedAmount = matchedAmountSet1 + resolvedMatchedBreaksSet1 + resolvedMismatchedBreaksSet1 + resolvedMismatchedBreaksSet2 
    
    // Update pie chart data
    const pieData = {
        labels: ['Matched', 'Unmatched'],
        datasets: [
            {
                data: [matchedAmount, unmatchedAmountSet],
                backgroundColor: ['#1a9338', '#e7f138'], // Adjust colors as needed
            },
        ],
    };
    
    // Pie chart options
    const pieOptions = {
        responsive: true,
        maintainAspectRatio: true,
        cutout: '75%',
        plugins: {
            datalabels: {
                display: false,
                color: 'black',
                align: 'end',
                anchor: 'end',
                formatter: (value, context) => `${context.chart.data.labels[context.dataIndex]}: ${value}%`,
            },
        },
    };
    
    

    // CSS style to adjust the chart size
    const chartStyle = {
        width: '130px',  // Width of the chart
        height: '130px'  // Height of the chart
    };

    const statusPieData = {
        
        labels: ['Unresolved', 'In-Progress', 'Resolved'],
        datasets: [{
          data: [statusCounts['Unresolved'], statusCounts['In-Progress'], statusCounts['Resolved']],
          backgroundColor: ['#f54b42', '#e7f138', '#1a9338'],  // Red, Orange, Green

        
        }]
      };
      
      const statusPieOptions = {
        responsive: true,
        maintainAspectRatio: true,
        cutout: '75%',
        plugins: {
          datalabels: {
            display: true,
            color: 'white',
            formatter: (value) => value > 0 ? value : null,
          }
        }
      };
      

    

      return (
        <div className="recon-metrics-display">


    {/* Matched vs Unmatched */}
    <div className="recon-metric-column">
        <h3 className="recon-metric-title">Matched vs Unmatched</h3>
        <div className="chart-and-stats">
          <div className="recon-metric-content chart-container" style={chartStyle}>
            <Doughnut data={pieData} options={pieOptions} />
          </div>
          <div className="chart-stats matched-chart-stats">
          <p>Matched: {matchedAmount}</p>
<p>Unmatched: {unmatchedAmountSet}</p>

          </div>
        </div>
      </div>


{/* File Overview */}
        <div className="recon-metric-column">
                <h3 className="recon-metric-title">File Overview</h3>
                <div className="recon-metric-content">

                 
                    <p>SideA: <strong>{recentFilename1}</strong></p>
                    <p>SideB: <strong>{recentFilename2}</strong></p>
                  

                </div>
            </div>

            

{/* Break Counts */}
<div className="recon-metric-column">
    <h3 className="recon-metric-title">Break Counts</h3>
    <div className="recon-metric-content">
        {breakCounts.map((breakItem) => (
            breakItem['# of breaks'] > 0 && breakItem.column_name !== 'matched_df' && (
                <p key={breakItem.column_name}>
                    {breakItem.column_name}: {breakItem['# of breaks']}
                </p>
            )
        ))}
    </div>
</div>


{/* Value of Breaks */}
<div className="recon-metric-column">
    <h3 className="recon-metric-title">Value of Breaks</h3>
    <div className="recon-metric-content">
        {breakCounts.map((breakItem) => (
            breakItem['value of breaks'] > 0 && breakItem.column_name !== 'matched_df' && (
                <p key={breakItem.column_name}>
                    {breakItem.column_name}: {formatValue(breakItem.column_name, breakItem['value of breaks'])}
                </p>
            )
        ))}
    </div>
</div>


        

                  {/* Status */}
                  <div className="recon-metric-column">
        <h3 className="recon-metric-title">Status Distribution</h3>
        
        <div className="chart-and-stats">
        <div className="chart-stats">
            <p>Unresolved: {statusCounts['Unresolved']}</p>
            <p>In-Progress: {statusCounts['In-Progress']}</p>
            <p>Resolved: {statusCounts['Resolved']}</p>
          </div>
          <div className="recon-metric-content status-chart-container" style={chartStyle}>
  <Doughnut data={statusPieData} options={statusPieOptions} />
</div>

         
        </div>
      </div>


   



            
        </div>
    );
}

export default ReconciliationMetricsDisplay;
